import React from "react";

function Header() {
    return(
<header className="App-header">

</header>);
}

export default Header;